import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AppInfoService } from 'core/app-info/app-info.service';
import { SignalRService } from 'core/signalR-service/signal-r.service';
import { SignalrProgressState } from '../entities/signalrProgressState.enum';
import { Icon } from '../icon/icon.enum';
import { AppLocalization } from '../entities/app-localization';

@Component({
  selector: 'app-go-online-sync',
  templateUrl: './sync-stepper.component.html',
  styleUrls: ['./sync-stepper.component.scss'],
  standalone: false
})
export class SyncStepperComponent implements OnInit {
  appStrings: AppLocalization;
  appIcon: string;
  syncStep: string;
  syncStepIndex = 0;
  syncWithError = false;
  private subs = new Subscription();

  syncStepsProgress;
  unsuccessfullySyncIcon;
  syncFor = {
    goOffline: false,
    goOnline: false
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SyncStepperComponent>,
    private appInfoService: AppInfoService,
    private signalrService: SignalRService,
  ) { }

  ngOnInit() {
    this.appIcon = Icon.logo;
    this.unsuccessfullySyncIcon = Icon.syncUnsuccessfully;
    this.appStrings = this.appInfoService.appStrings;

    this.syncFor = this.data;
    this.initSyncSteps();
    this.subs.add(this.signalrService.startedGoOnlineSyncProgressReceived$
      .subscribe(progress => this.setStartedSyncProgress(progress)));
    this.subs.add(this.signalrService.receiveOnlineUpdatesProgressReceived$
      .subscribe(progress => this.setStartedSyncProgress(progress)));
  }

  /**
   * Sets the progress received from signalR messages
   * @param as progress
   */
  private setStartedSyncProgress(progress) {
    if (progress.state === SignalrProgressState.InProgress) {
      this.handleSyncStep(progress.message);
    }

    if (progress.state === SignalrProgressState.Done) {
      this.dialogRef.close();
    }

    if (progress.state === SignalrProgressState.Error) {
      this.syncWithError = true;
    }
  }

  /**
   * Init the values for sync steps
   */
  private initSyncSteps() {
    this.syncStepIndex = 0;
    if (this.syncFor.goOnline) {
      this.syncStepsProgress = [
        {
          key: this.appStrings.goOnline_quotesAndOrdersSync,
          inProgress: true,
          done: false
        },
        {
          key: this.appStrings.goOnline_changeAppSettingsSync,
          inProgress: true,
          done: false
        },
        {
          key: this.appStrings.goOnline_sendingOrdersSync,
          inProgress: true,
          done: false
        }
      ];
    } else {
      this.syncStepsProgress = [
        {
          key: this.appStrings.goOffline_syncingCustomers,
          inProgress: true,
          done: false
        },
        {
          key: this.appStrings.goOffline_syncingAddresses,
          inProgress: true,
          done: false
        },
        {
          key: this.appStrings.goOffline_syncingProducts,
          inProgress: true,
          done: false
        },
        {
          key: this.appStrings.goOffline_syncingPricing,
          inProgress: true,
          done: false
        },
        {
          key: this.appStrings.goOffline_syncingMiscData,
          inProgress: true,
          done: false
        },
        {
          key: this.appStrings.goOnline_quotesAndOrdersSync,
          inProgress: true,
          done: false
        }
      ];
    }
    this.syncStep = this.syncStepsProgress[0].key;
  }

  /**
   * Handles each sync step
   * @param stepProgress - the progress of each sync step
   */
  private handleSyncStep(stepProgress) {
    let choice;
    this.syncStep = stepProgress.stepName;

    this.syncStepsProgress.forEach(step => {
      if (step.key && step.key.includes(this.syncStep)) {
        choice = this.syncStepsProgress.indexOf(step);
      }
    });

    if (typeof choice !== 'undefined') {
      this.syncStepsProgress[choice].inProgress = stepProgress.state === SignalrProgressState.InProgress;
      this.syncStepsProgress[choice].done = stepProgress.state === SignalrProgressState.Done;
      this.syncStepIndex = choice;
    }
  }

  /**
   * Retries the sync
   */
  retry() {
    this.dialogRef.close(1);
  }

  /**
   * Cancels the sync
   */
  cancel() {
    this.dialogRef.close(2);
  }

}
